// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23A8z","delete":"styles_delete__GscJf","update":"styles_update__2TSeH","add":"styles_add__1tI8u"};